import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@crm/ui/components/ui/dropdown-menu";
import { Link } from "@tanstack/react-router";
import { Option } from "effect";
import * as AsyncResult from "effect/unstable/reactivity/AsyncResult";
import { Check, ChevronsUpDown, Globe, Plus, Settings2 } from "lucide-react";
import { useMySites, useSetActiveSite } from "#app/sites";

/**
 * 全局站点切换器（sites 主干的唯一入口）。
 * 位于顶栏右侧：显示当前活动站点，下拉切换/新建/管理。
 */
export function SiteSwitcher() {
  const mySitesResult = useMySites();
  const data = AsyncResult.value(mySitesResult).pipe(Option.getOrUndefined);
  const isLoading = AsyncResult.isWaiting(mySitesResult);
  const setActive = useSetActiveSite();

  const sites = data?.success ? data.data.sites : [];
  const activeSiteId = data?.success ? data.data.activeSiteId : null;
  const activeSite = sites.find((s) => s.id === activeSiteId);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="inline-flex h-8 items-center gap-1.5 rounded-full border border-border bg-card px-3.5 font-medium text-[12.5px] text-ink-2 transition-colors hover:border-[#D8D4CC] hover:shadow-s"
          type="button"
        >
          <Globe className="text-brand-text" size={14} />
          <span className="max-w-[140px] truncate">
            {isLoading ? "加载中…" : (activeSite?.name ?? (sites.length ? "选择站点" : "创建站点"))}
          </span>
          <ChevronsUpDown className="text-ink-3" size={13} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-[11px] text-ink-3">我的站点</DropdownMenuLabel>
        {sites.map((site) => (
          <DropdownMenuItem
            key={site.id}
            onSelect={() => {
              if (site.id !== activeSiteId) {
                setActive.execute(site.id);
              }
            }}
          >
            <span className="flex-1 truncate">{site.name}</span>
            {site.id === activeSiteId ? <Check className="text-success" size={14} /> : null}
          </DropdownMenuItem>
        ))}
        {sites.length > 0 ? <DropdownMenuSeparator /> : null}
        <DropdownMenuItem asChild>
          <Link search={{ create: true }} to="/sites">
            <Plus size={14} />
            新建站点
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/sites">
            <Settings2 size={14} />
            管理站点
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
